/**
 * Service for managing recent contacts in localStorage
 */

const STORAGE_KEY_PREFIX = 'peoplevue_recent_contacts_';
const MAX_RECENT = 8; // Show up to 8 recent contacts

/**
 * Get recent contacts for a user
 * @param {string} userId - Current user ID
 * @returns {Array} Array of {employeeId, timestamp, name} objects, sorted by most recent
 */
export function getRecentContacts(userId) {
  try {
    const stored = localStorage.getItem(`${STORAGE_KEY_PREFIX}${userId}`);
    if (!stored) return [];

    const contacts = JSON.parse(stored);
    // Return sorted by most recent timestamp
    return contacts.sort((a, b) => b.timestamp - a.timestamp);
  } catch (error) {
    console.error('Failed to load recent contacts:', error);
    return [];
  }
}

/**
 * Add a contact to recent contacts
 * @param {string} userId - Current user ID
 * @param {string} employeeId - Employee being contacted
 * @param {string} employeeName - Employee's display name
 */
export function addRecentContact(userId, employeeId, employeeName) {
  try {
    // Don't track if viewing yourself
    if (userId === employeeId) return;

    let contacts = getRecentContacts(userId);

    // Remove existing entry for this employee if present
    contacts = contacts.filter(c => c.employeeId !== employeeId);

    // Add new entry at the front
    contacts.unshift({
      employeeId,
      name: employeeName,
      timestamp: Date.now()
    });

    // Keep only the most recent MAX_RECENT
    contacts = contacts.slice(0, MAX_RECENT);

    localStorage.setItem(`${STORAGE_KEY_PREFIX}${userId}`, JSON.stringify(contacts));
  } catch (error) {
    console.error('Failed to save recent contact:', error);
  }
}

/**
 * Clear all recent contacts for a user
 * @param {string} userId - Current user ID
 */
export function clearRecentContacts(userId) {
  try {
    localStorage.removeItem(`${STORAGE_KEY_PREFIX}${userId}`);
  } catch (error) {
    console.error('Failed to clear recent contacts:', error);
  }
}
